import { actionTypes } from 'redux-firestore';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { getActiveCategory, getEvents } from '../selectors';
import moment from 'moment/moment';

import { ACTIVE_CATEGORY_SET, changeActiveCategory } from '../../actions/categories';
import { ALL_CATEGORIES, PAGE_SIZE } from '../../../constants/events';
import AMPLITUDE_EVENT_NAMES from '../../../amplitude/constants';
import { COLLECTION } from '../../../constants/collection';
import {
  EVENT_FETCHED,
  EVENTS_FETCHED,
  requestEvents,
  requestEventsError,
  requestEventsSuccess,
  resetEvents,
} from '../../actions/events';
import { FIELDS } from '../../../constants/eventForm';
import { logAmplitudeEvent } from '../../actions/amplitude';
import store from '../../store/store';

const { CLEAR_DATA } = actionTypes;
let referenceToOldestKey = null;

const fetchEvents = function* fetchEvents() {
  yield put(requestEvents());
  const nowDateTime = moment().unix();
  const activeCategory = yield select(getActiveCategory);
  const options = {
    collection: COLLECTION.EVENTS,
    limit: PAGE_SIZE,
    startAfter: referenceToOldestKey,
  };
  try {
    if (activeCategory && activeCategory !== ALL_CATEGORIES.value) {
      yield put({
        type: CLEAR_DATA,
        preserve: { data: ['userEvents'], ordered: ['userEvents'] },
      });
      const path = `${FIELDS.CATEGORIES}.${activeCategory}`;
      yield store.firestore.get({
        ...options,
        where: [path, '>', nowDateTime],
        orderBy: path,
      });
    } else {
      yield store.firestore.get({
        ...options,
        where: [FIELDS.START_DATE_TIME, '>', nowDateTime],
        orderBy: [FIELDS.START_DATE_TIME],
      });
    }

    const events = yield select(getEvents);
    referenceToOldestKey = events[events.length - 1][FIELDS.START_DATE_TIME];
    yield put(requestEventsSuccess(events || []));
  } catch(err) {
    yield put(requestEventsError());
  }
};

const watchFetchEvents = function* watchFetchEvents() {
  yield takeLatest(EVENTS_FETCHED, fetchEvents);
};

const setActiveCategory = function* setActiveCategory({ category }) {
  const activeCategory = yield select(getActiveCategory);
  if (activeCategory !== category.value) {
    yield put(changeActiveCategory(category));
    yield put(resetEvents());
    referenceToOldestKey = null;
    yield call(fetchEvents);
  }
};

const watchActiveCategorySet = function* watchActiveCategorySet() {
  yield takeLatest(ACTIVE_CATEGORY_SET, setActiveCategory);
};

const fetchEvent = function* fetchEvent({ eventId }) {
  const res = yield store.firestore.get({
    collection: COLLECTION.EVENTS,
    doc: eventId,
    storeAs: 'event',
  });
  const { categories, startDateTime, title } = res.data();
  yield put(logAmplitudeEvent(AMPLITUDE_EVENT_NAMES.EVENT_DETAIL_FETCH, {
    id: res.id,
    categories: Object.keys(categories),
    startDateTime: startDateTime,
    title: title,
  }));
};

const watchFetchEvent = function* watchFetchEvent() {
  yield takeLatest(EVENT_FETCHED, fetchEvent);
};

export {
  watchActiveCategorySet,
  watchFetchEvent,
  watchFetchEvents,
};



// WEBPACK FOOTER //
// ./src/redux/sagas/events/fetch.js